var React = require('react');

function PlayCircleFill (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.3848 44C35.4305 44 44.3848 35.0457 44.3848 24C44.3848 12.9543 35.4305 4 24.3848 4C13.3391 4 4.38477 12.9543 4.38477 24C4.38477 35.0457 13.3391 44 24.3848 44Z","stroke":"white","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M20.3848 16L32.3848 24L20.3848 32V16Z","fill":"white","stroke":"white","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

PlayCircleFill.defaultProps = {"width":"49","height":"48","viewBox":"0 0 49 48","fill":"none"};

module.exports = PlayCircleFill;

PlayCircleFill.default = PlayCircleFill;
